import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';

export const importFileTypesProcErknm: (keyof typeof UploadFileTypesEnum)[] = ['ERKNM_PLAN_CORRECTION'];
